import step1 from "src/assets/images/verification/icon-step-1.png";
import step2 from "src/assets/images/verification/icon-step-2.png";
import step3 from "src/assets/images/verification/icon-step-3.png";
import step4 from "src/assets/images/verification/icon-step-4.png";
import step5 from "src/assets/images/verification/icon-step-5.png";

export const PERCENTAGE = {
  none: 0,
  email: 25,
  phone: 50,
  identity: 75,
  company: 99
};

export const STEP_IMAGE = {
  none: step1,
  email: step2,
  phone: step3,
  identity: step4,
  company: step5
};

export const TRIAL_INACTIVE = "INACTIVE";
export const TRIAL_ACTIVE = "ACTIVE";

export const DATE_RANGE = {
  WEEK: "week",
  MONTH: "month",
  YEAR: "year"
};

export const DATE_TYPE = {
  WEEK_OR_MONTH: 1,
  YEAR: 2
};

export const WELCOME_MODAL_ACK = "bf-welcome-modal-trial";

export const BANK_INFO = {
  2: {
    label: "delay",
    color: "yellow"
  },
  3: {
    label: "down",
    color: "red"
  }
};
